import * as ko from "knockout";

/*
 * Helper class for serial task viewmodel
 * */
class WorkItemSerialDialogViewModel {
    // #region Properties

    /** Id of work item reccuring */
    WorkItemRecurringId: KnockoutObservable<string> = ko.observable<string>();
    /** Id of work item  */
    WorkItemId: KnockoutObservable<string> = ko.observable<string>();
    /** Number of work items belonging to the series */
    NumberOfOccurrences: KnockoutObservable<number> = ko.observable<number>();
    /** A kind of repeating cycle */
    RecurringCycle: KnockoutObservable<number> = ko.observable<number>();
    /** Day of the month number */
    DayOfMonth: KnockoutObservable<number> = ko.observable<number>();
    /** Month of the year as a number */
    MonthOfYear: KnockoutObservable<number> = ko.observable<number>();
    /** End date in the format yyyyMMddHHmmss */
    EndTimeJs: KnockoutObservable<string> = ko.observable<string>();
    /** Array of selected days */
    SelectedDays: KnockoutObservableArray<string> = ko.observableArray<string>();
    /** Reccuring Type - daily, weekly, monthly, yearly */
    RecurringType: KnockoutObservable<string> = ko.observable<string>();
    /** If true, it means that no serial task definition does not exist in the database yet `*/
    IsNew: KnockoutObservable<boolean> = ko.observable<boolean>();
    /** Repeatability option selected. Mainly used to display the view correctly */
    SelectedOption: KnockoutObservable<string> = ko.observable<string>();
    /** Cycle value - option 1 */
    CycleValue1: KnockoutObservable<number> = ko.observable<number>();
    /** Cycle value - option 2 */
    CycleValue2: KnockoutObservable<number> = ko.observable<number>();
    /** Type of repetition end, e.g. date, number of repetitions or endless */
    EndOptionValue: KnockoutObservable<string> = ko.observable<string>('1');

    // #endregion
}
export default WorkItemSerialDialogViewModel;